import { render, staticRenderFns } from "./SearchFilterv2.vue?vue&type=template&id=8ff1a768&scoped=true"
import script from "./SearchFilterv2.vue?vue&type=script&lang=js"
export * from "./SearchFilterv2.vue?vue&type=script&lang=js"
import style0 from "./SearchFilterv2.vue?vue&type=style&index=0&id=8ff1a768&prod&scoped=true&lang=css"
import style1 from "./SearchFilterv2.vue?vue&type=style&index=1&id=8ff1a768&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff1a768",
  null
  
)

export default component.exports